import { AfterViewInit, Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AuthenticationService } from './authentication/authentication.service';
import { AppNotificationComponent } from './shared/components/app-notification/app-notification.component';
import { ImageUrl } from './shared/constants/image--url-constant';
import { SwUpdate } from '@angular/service-worker';
import { TitleService } from './title.service';
import { AppInsightsService } from './framework/service/app-insights.service';
import { MatDialog } from '@angular/material/dialog';
import { MessagingService } from './messaging.service';

@Component({
    selector: 'vc-root',
    templateUrl: './app.component.html',
    standalone: false
})

export class AppComponent implements OnInit, AfterViewInit {

  logo: string;
  clientDetails;
  programmeDetails: any;
  appDetails
  getImagePath;
 
  constructor(
    private readonly title: Title,
    private readonly authenticationService: AuthenticationService,
    private readonly renderer: Renderer2,
    private swUpdate: SwUpdate,
    private titleService: TitleService,
    private readonly appInsightsService: AppInsightsService,
  ) {
    this.title.setTitle('Sign In');       

  }

  ngOnInit() {
    this.loadApplication();
  }

     @HostListener('keyup',['$event']) keyUpEvent(event: Event) {
      if(localStorage.getItem('userId')){
        this.appInsightsService.logEvent(""+event.type,{'userId':localStorage.getItem('userId') , session_uuid:localStorage.getItem('session_uuid')});
      }else{
        this.appInsightsService.logEvent(""+event.type);
      }
    }
    @HostListener('click',['$event']) clickEvent(event: Event) {
      if(localStorage.getItem('userId')){
        this.appInsightsService.logEvent(""+event.type , {'userId':localStorage.getItem('userId') , session_uuid:localStorage.getItem('session_uuid')});
     
      }else{
        this.appInsightsService.logEvent(""+event.type);
      }
    }
    @HostListener('dblclick',['$event']) doubleClick(event: Event) {
      this.appInsightsService.logEvent(""+event.type);
    }
    @HostListener('submit',['$event']) submit(event: Event) {
      this.appInsightsService.logEvent(""+event.type);
    }
    @HostListener('drag',['$event']) drag(event: Event) {
      this.appInsightsService.logEvent(""+event.type);
    }
    @HostListener('drop',['$event']) drop(event: Event) {
      this.appInsightsService.logEvent(""+event.type);
    }

    @HostListener('window:scroll',['$event']) scroll(event: Event) {
      if (localStorage.getItem('userId')) {
        this.appInsightsService.logEvent("" + event.type, { 'userId': localStorage.getItem('userId') , session_uuid:localStorage.getItem('session_uuid') });
      } else {
        this.appInsightsService.logEvent("" + event.type);
      }
    }

  
  loadApplication(){
    if (!environment.enableCtrl) {
      this.disableControls();
    }
    if (this.swUpdate.isEnabled) {
      console.log("Serviceworker update enabled ");
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          console.log('New version available', event.latestVersion);
          this.swUpdate.activateUpdate().then((activated) => {
            if (activated) {
              console.info('App update activated');
              window.location.reload();
            }
          }).catch((error) => {
            console.error(error);
          });
        }
      });

      this.swUpdate.checkForUpdate().then(() => {
        console.log("Got new Version");
      }).catch((error) => {
        console.error('Could not check for app updates', error);
      });
    }

    
    
      this.authenticationService.getClientDetails().subscribe(data => {
        this.clientDetails = data;
        localStorage.setItem('clientId', this.clientDetails.id);
        localStorage.setItem('ApplicationID',this.clientDetails.appId);
        localStorage.setItem('moodleUrl',this.clientDetails.moodleUrl)
        localStorage.setItem('isSelfRegisterAllowed',this.clientDetails.isSelfRegisterAllowed)
      });

      this.getAppInfoFromOrgranizationId()
  }


  getAppInfoFromOrgranizationId() {  
    const sessionToken = localStorage.getItem('sessionToken');
    if (!sessionToken) {
      return;
    }

    const orgId = JSON.parse(atob(sessionToken.split('.')[1])).orgId;
    this.authenticationService.getAppInfoByOrgId(orgId).subscribe(data => {
      
      localStorage.setItem('primaryAppColor',data.organizationUnitExtdRWS.primaryAppColour)
      localStorage.setItem('secondaryAppColor',data.organizationUnitExtdRWS.secondaryAppColour)
      
      document.documentElement.style.setProperty('--primary-color', data.organizationUnitExtdRWS.primaryAppColour);
      document.documentElement.style.setProperty('--secondary-color', data.organizationUnitExtdRWS.secondaryAppColour);
     
      this.getImagePath = ImageUrl.IMAGES + data.organizationUnitExtdRWS.logoPath;
    
      localStorage.setItem('appLogo',this.getImagePath)
      console.log(this.getImagePath);
    })
  }

  disableControls() {

    function keyPressCheck(event) {
      if (event.keyCode === 123) {
        return false;
      }
    }

    document.oncontextmenu = function () {
      return false;
    }

    function disableCtrlKeyCombination(e) {
      //list all CTRL + key combinations you want to disable
      const forbiddenKeys = new Array('a', 'n', 'c', 'x', 'v', 'j', 'w');
      let key, isCtrl;

      if (window.event) {
        key = (<any>window.event).keyCode; //IE
        if ((<any>window.event).ctrlKey) {
          isCtrl = true;
        } else {
          isCtrl = false;
        }
      } else {
        key = e.which; //firefox
        if (e.ctrlKey) {
          isCtrl = true;
        } else {
          isCtrl = false;
        }
      }
      //if ctrl is pressed check if other key is in forbidenKeys array
      if (isCtrl) {
        for (let i = 0; i < forbiddenKeys.length; i++) {
          //case-insensitive comparation
          if (forbiddenKeys[i].toLowerCase() === String.fromCharCode(key).toLowerCase()) {
            return false;
          }
        }
      }
      return true;
    }
  }

  ngAfterViewInit() {
    this.disableUserWayCSS();
  }

  disableUserWayCSS() {
    const overrideStyle = document.createElement('style');
    const nonce = document.querySelector('script[nonce]')?.getAttribute('nonce');
    if (nonce) {
      overrideStyle.setAttribute('nonce', nonce);
    }
    overrideStyle.innerHTML = `
      body .uwy.userway_p1 .userway_buttons_wrapper {
        top: auto !important;
        bottom: 12px !important;
        transform: none !important;
        position: fixed !important;
        z-index: 9999 !important;
      }
      
      /* iPhone XS Max specific */
      @media only screen and (device-width: 414px) and (device-height: 896px) {
        body .uwy.userway_p1 .userway_buttons_wrapper {
          bottom: 16px !important;
        }
      }
      
      /* iPhone XS Max PWA mode */
      @media only screen and (device-width: 414px) and (device-height: 896px) and (display-mode: standalone) {
        body .uwy.userway_p1 .userway_buttons_wrapper {
          bottom: calc(env(safe-area-inset-bottom, 0px) + 16px) !important;
        }
      }
    `;
    
    document.head.appendChild(overrideStyle);
    console.log('UserWay positioning override injected');
        
      const observer = new MutationObserver(() => {
      const userWayWrapper = document.querySelector('.userway_buttons_wrapper');
      if (userWayWrapper) {
        // Force apply styles directly to element
        const element = userWayWrapper as HTMLElement;
        element.style.setProperty('top', 'auto', 'important');
        element.style.setProperty('bottom', '12px', 'important');
        element.style.setProperty('right', '16px', 'important');
        element.style.setProperty('left', 'auto', 'important');
        element.style.setProperty('transform', 'none', 'important');
        element.style.setProperty('position', 'fixed', 'important');
        console.log('UserWay positioning forced via inline styles');
        
        // Disconnect observer after successful styling
        observer.disconnect();
        console.log('UserWay observer disconnected');
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }
}
